import { IonIcon } from '@ionic/react';
import { caretForward } from 'ionicons/icons';

export const SubInIcon: React.FC = () => (
  <IonIcon icon={caretForward} style={{ color: 'green' }} />
);
